"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findClosestTo = void 0;
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var minigolfCreatures_sidecar_1 = require("./minigolfCreatures-sidecar");
var findClosestTo = function (px, py) {
    var objs = minigolfCreatures_sidecar_1.minigolfCreatures.getAll();
    // console.log('objs pre', objs.length)
    objs = objs.filter(function (obj) {
        return obj.data.pickupType === 'stairs-down' ||
            obj.data.pickupType === 'stairs-up';
    });
    // console.log('objs', objs.length)
    var closest = null;
    var closest_dist = 9999999;
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        if (obj.isDead) {
            continue;
        }
        var pos = obj.rigidBody.translation();
        var dist = mathUtils_sidecar_1.mathUtils.distance(px, py, pos.x, pos.y);
        if (dist < closest_dist) {
            closest_dist = dist;
            closest = obj;
        }
    }
    return closest;
};
exports.findClosestTo = findClosestTo;
